import type { FlexibleWorkingHoursView, FlexibleWorkingHours, Location } from "owa-graph-schema";

export default function getCurrentSegmentWorkLocationDetails(segment: FlexibleWorkingHoursView | FlexibleWorkingHours): Location | null {
    return segment.workLocationDetails ?? null;
}
